var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-document-footer"}},[_c('p',{staticClass:"footer-text p-2"},[_vm._v("\n    พบ "+_vm._s(_vm.data?_vm.data.length:_vm.orders.length)+" รายการ\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }